import { TextSubstitutionValues } from './builderDocument';

export enum AutomaticTextPlaceholders {
    Location = 'location',
    Address = 'address',
    AddressSingleLine = 'address-singeline',
    Phone = 'phone',
    Email = 'email',
    Website = 'website',
}

const placeholdersToPreventEmptyString = new Set([
    AutomaticTextPlaceholders.Address,
    AutomaticTextPlaceholders.AddressSingleLine,
    AutomaticTextPlaceholders.Phone,
    AutomaticTextPlaceholders.Email,
    AutomaticTextPlaceholders.Website,
]);

export function substituteText(values: TextSubstitutionValues, text: string | null): string {
    if (!text) {
        return '';
    }

    let keys = '';
    for (const substitutionKey in values) {
        // eslint-disable-next-line no-prototype-builtins
        if (values.hasOwnProperty(substitutionKey)) {
            if (keys !== '') {
                keys += '|';
            }
            keys += substitutionKey;
        }
    }

    const regex = new RegExp(`{(${keys})}`, 'gi');
    const result = text.replace(regex, (match, key) => {
        const replaceValue = values[key];
        if (replaceValue) {
            return replaceValue;
        } else if (replaceValue === '' && !placeholdersToPreventEmptyString.has(key)) {
            return replaceValue;
        } else {
            return match;
        }
    });

    return result;
}
